<template>
  <div>
    <dashboard-header :text="item ? $t('schedule.updateSchedule'): $t('schedule.createSchedule')" :on-back="onGoBack"/>
    <div class="d-flex justify-center align-center">
      <v-card elevation="0"
              class="card-border-10 w-75">
        <v-card class="m-4"
                outlined>
          <div class="d-flex custom-card-head p-4">
            <div class="d-inline text-sm-h5 ">{{ $t("nav.about") }}</div>
          </div>
          <v-divider class="m-0"></v-divider>
          
          <!-- Employee Selection - Required -->
          <div class="pa-4">
            <div class="d-flex text-body-1">
              <div class="text-h6 mark-title me-2">*</div>
              {{ labelEmployee }}
            </div>
            <v-autocomplete
                v-model="selectedEmployee"
                :items="listEmployee"
                :placeholder="select"
                item-text="name"
                deletable-chips
                return-object
                outlined
                dense
                clearable
                hide-no-data
                :filter="filterEmployee"
            ></v-autocomplete>
          </div>

          <!-- Time Selection - Optional -->
          <div class="pa-4">
            <div class="d-flex text-body-1">
              {{ labelTime }}
              <span class="text-caption ml-2 text--secondary">{{ $t('schedule.timeOptional') }}</span>
            </div>

            <v-dialog
                v-model="timePicker"
                persistent
                max-width="800px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="selectedTime"
                    @click="isOpenTime"
                    :placeholder="$t('base.selectOption')"
                    append-icon="mdi-clock-time-four-outline"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    outlined
                    dense
                    clearable
                    @click:clear="clearTime"
                ></v-text-field>
              </template>

              <v-card>
                <v-card-title class="text-h6">
                  {{ $t('schedule.selectTime') }}
                </v-card-title>
                
                <div class="d-flex">
                  <div class="w-50 ma-4">
                    <div class="text-h5">
                      {{ $t("schedule.start") }}
                    </div>
                    <v-time-picker
                        full-width
                        v-model="pickStartTime"
                    ></v-time-picker>
                  </div>

                  <div class="w-50 ma-4">
                    <div class="text-h5">
                      {{ $t("schedule.end") }}
                    </div>
                    <v-time-picker
                        full-width
                        v-model="pickEndTime"
                    ></v-time-picker>
                  </div>
                </div>
                
                
                <div class="d-flex pa-4">
                  <v-btn
                      outlined
                      elevation="0"
                      class="ms-auto no-uppercase"
                      @click="cancelSelectTime"
                  >
                    {{ $t("ui.cancel") }}
                  </v-btn>
                  <v-btn
                      @click="confirmSelectTime"
                      :disabled="isSaveTimeDisabled"
                      class="ms-2 no-uppercase"
                      elevation="0"
                      color="info">
                    {{ $t("ui.select") }}
                  </v-btn>
                </div>
              </v-card>
            </v-dialog>
          </div>

          <!-- Date Selection - Optional -->
          <div class="pa-4">
            <div class="d-flex text-body-1">
              {{ labelDate }}
              <span class="text-caption ml-2 text--secondary">{{ $t('schedule.dateOptional') }}</span>
            </div>

            <v-dialog
                v-model="dialog"
                persistent
                width="800px">
              <template v-slot:activator="{ on, attrs }">
                <v-card
                    @click="isOpenDate"
                    class="no-uppercase text-h5 px-4 py-1 d-flex"
                    elevation="0"
                    outlined
                    v-bind="attrs"
                    v-on="on">
                  <span :style="!startDate ? { color: '#9E9E9E', 'font-size': '22px' } : {'font-size': '22px'}">{{ textStartDate }}</span>
                  <img class="ms-auto me-4"
                       :src="require('@/assets/images/ic-arrow-calendar.svg')"/>
                  <span :style="!endDate ? { color: '#9E9E9E', 'font-size': '22px' } : {'font-size': '22px'}">{{ textEndDate }}</span>
                  <img class="ms-auto"
                       :src="require('@/assets/images/ic-calendar.svg')"/>
                </v-card>
              </template>

              <v-card>
                <v-card-title class="text-h6">
                  {{ $t('ui.selectTimePeriod') }}
                </v-card-title>

                <div class="d-flex mx-6">
                  <div class="w-50">
                    <div class="d-flex">
                      <div
                          :class="'circle-border text-body-1 align-content-center ' + circleDateClass(pickStartDate)">
                        1
                      </div>
                      <div class="text-body-1 align-content-center mx-2">{{ textPickStartDate }}</div>
                      <v-btn v-if="pickStartDate"
                             @click="pickStartDate = null"
                             class="align-content-center my-auto"
                             icon
                             small>
                        <v-icon>mdi-close-circle-outline</v-icon>
                      </v-btn>
                    </div>

                    <v-date-picker
                        class="mt-6"
                        color="blue darken-1"
                        no-title
                        full-width
                        :locale="locale==='en' ? 'en-us' : 'vi-vn'"
                        v-model="pickStartDate"
                        :max="pickEndDate"
                        scrollable>
                    </v-date-picker>
                  </div>
                  <div class="w-50">
                    <div class="d-flex">
                      <div
                          :class="'circle-border text-body-1 align-content-center ' + circleDateClass(pickEndDate)">
                        2
                      </div>
                      <div class="text-body-1 align-content-center mx-2">{{ textPickEndDate }}</div>
                      <v-btn v-if="pickEndDate"
                             @click="pickEndDate = null"
                             class="align-content-center my-auto"
                             icon
                             small>
                        <v-icon>mdi-close-circle-outline</v-icon>
                      </v-btn>
                    </div>
                    <v-date-picker
                        class="mt-6"
                        color="blue darken-1"
                        no-title
                        full-width
                        :min="pickStartDate"
                        :locale="locale==='en' ? 'en-us' : 'vi-vn'"
                        v-model="pickEndDate"
                        scrollable>
                    </v-date-picker>
                  </div>
                </div>

                <!-- Date Dialog Actions - Chỉ giữ Cancel -->
                <div class="d-flex pa-4">
                  <v-btn
                      outlined
                      elevation="0"
                      class="ms-auto no-uppercase"
                      @click="cancelSelectDate"
                  >
                    {{ $t("ui.cancel") }}
                  </v-btn>
                  <v-btn
                      :disabled="isSelectDisabled"
                      :outlined="isSelectDisabled"
                      class="ms-2 no-uppercase"
                      elevation="0"
                      @click="confirmSelectDate"
                      color="info"
                  >
                    {{ $t("ui.select") }}
                  </v-btn>
                </div>
              </v-card>
            </v-dialog>

            <!-- Clear Date Button bên ngoài dialog -->
            <div class="mt-2" v-if="startDate || endDate">
              <v-btn 
                small 
                outlined 
                @click="onClearDate"
                class="no-uppercase">
                {{ $t("ui.clear") }}
              </v-btn>
            </div>
          </div>

          <!-- Repeat Selection - Optional -->
          <div class="px-4 pt-4">
            <div class="d-flex text-body-1">
              {{ labelRepeat }}
              <span class="text-caption ml-2 text--secondary">{{ $t('schedule.repeatOptional') }}</span>
            </div>

            <div class="d-flex text-body-1">
              <v-checkbox
                  class="me-4"
                  v-for="day in listDayOfWeek"
                  :key="day.value"
                  v-model="selectRepeat"
                  :label="day.text"
                  :value="day.value">
                <template v-slot:label>
                  <div class="mt-2">{{ day.text }}</div>
                </template>
              </v-checkbox>
            </div>
            
            <!-- Clear repeat button -->
            <div class="mt-2" v-if="selectRepeat.length > 0">
              <v-btn 
                small 
                outlined 
                @click="clearRepeat"
                class="no-uppercase">
                {{ $t("ui.clearAll") }}
              </v-btn>
            </div>
          </div>

          <!-- Group Selection -->
          <div class="px-4">
            <div class="d-flex text-body-1">
              <v-switch
                  inset
                  v-model="isGroup"
                  @change="onSwitchChange">
              </v-switch>
              <div class="my-auto">
                {{ labelGroup }}
              </div>
            </div>
            <div v-if="isGroup">
              <div class="d-flex text-body-1">
                <div class="text-h6 mark-title me-2">*</div>
                {{ labelDutyGroup }}
              </div>
              <v-select
                  v-model="selectedGroup"
                  :items="listGroup"
                  :placeholder="labelSelectGroup"
                  item-text="name"
                  deletable-chips
                  return-object
                  outlined
                  dense
              ></v-select>
            </div>
          </div>

          <!-- Business Logic Info -->
          <div class="pa-4">
            <v-alert 
              type="info" 
              dense 
              text
              class="mb-0">
              <div class="text-body-2">
                <strong>{{ $t('schedule.businessLogicTitle') }}:</strong>
              </div>
              <ul class="text-caption mt-2">
                <li>{{ $t('schedule.businessLogicTime') }}</li>
                <li>{{ $t('schedule.businessLogicDate') }}</li>
                <li>{{ $t('schedule.businessLogicRepeat') }}</li>
              </ul>
            </v-alert>
          </div>

          <!-- Validation Info -->
          <div class="pa-4" v-if="!enableOnSave && selectedEmployee">
            <v-alert 
              type="warning" 
              dense 
              text
              class="mb-0">
              <div class="text-body-2">
                {{ $t('schedule.validationMessage') }}
              </div>
            </v-alert>
          </div>

        </v-card>
        <div class=" m-4">
          <v-btn
              elevation="0"
              class="no-uppercase btn-custom-primary"
              @click="onSave"
              :disabled="!enableOnSave"
          >{{ $t('ui.save') }}
          </v-btn>
        </div>

      </v-card>
    </div>
  </div>
</template>

<script>
import DashboardHeader from "../component/DashboardHeader";
import {API2} from "../../api";
import mixin from "../../mixin";
import i18n from "../../lang/i18n";
import {DAY_OF_WEEK, SCHEDULE_ACTION_TYPE, TYPE_FORMAT_TIME} from "../../config/constant";
import moment from "moment/moment";
import {mapState} from "vuex";

export default {
  name: "CreateOrUpdate",
  components: {DashboardHeader},
  mixins: [mixin],
  props: {
    openTab: {
      type: Function,
      required: true
    },
    item: {
      type: Object,
    }
  },
  data() {
    return {
      schedule: null,
      listEmployee: [],
      selectedEmployee: null,
      // time picker
      timePicker: false,
      startTime: null,
      endTime: null,
      pickStartTime: null,
      pickEndTime: null,
      mainOnDuty: true,
      // isGetNotifications
      isGetNotifications: true,
      selectRepeat: [],
      isGroup: false,
      listGroup: [],
      selectedGroup: null,

      startDate: null,
      endDate: null,
      pickStartDate: null,
      pickEndDate: null,
      dialog: false,
    }
  },
  mounted() {
    this.onTab(this.item)
  },
  computed: {
    ...mapState(['locale', 'accountInfo']),
    selectedTime() {
      if (!this.startTime && !this.endTime) {
        return ""
      }
      let startTime = this.startTime ? this.startTime : ''
      let endTime = this.endTime ? this.endTime : ''
      return `${startTime} - ${endTime}`
    },
    selectedDateRange() {
      if (!this.startDate && !this.endDate) return ""
      const start = this.startDate ? this.formatDate(this.startDate, TYPE_FORMAT_TIME.DD_MM_YYYY) : ""
      const end = this.endDate ? this.formatDate(this.endDate, TYPE_FORMAT_TIME.DD_MM_YYYY) : ""
      return `${start} - ${end}`
    },
    labelEmployee() {
      return i18n.t("schedule.employee")
    },
    labelTime() {
      return i18n.t("schedule.time")
    },
    labelDate() {
      return i18n.t("schedule.date")
    },
    labelRepeat() {
      return i18n.t("schedule.day")
    },
    labelGroup() {
      return i18n.t("schedule.isGroup")
    },
    labelSelectGroup() {
      return i18n.t("base.selectOption")
    },
    labelDutyGroup() {
      return i18n.t("schedule.selectGroup")
    },
    // repeat
    listDayOfWeek() {
      return [
        {
          text: i18n.t("schedule.everyMonday"),
          value: DAY_OF_WEEK.MONDAY
        },
        {
          text: i18n.t("schedule.everyTuesday"),
          value: DAY_OF_WEEK.TUESDAY
        },
        {
          text: i18n.t("schedule.everyWednesday"),
          value: DAY_OF_WEEK.WEDNESDAY
        },
        {
          text: i18n.t("schedule.everyThursday"),
          value: DAY_OF_WEEK.THURSDAY
        },
        {
          text: i18n.t("schedule.everyFriday"),
          value: DAY_OF_WEEK.FRIDAY
        },
        {
          text: i18n.t("schedule.everySaturday"),
          value: DAY_OF_WEEK.SATURDAY
        },
        {
          text: i18n.t("schedule.everySunday"),
          value: DAY_OF_WEEK.SUNDAY
        }
      ]
    },
    //date picker
    textStartDate() {
      return this.getTextDateFormat(this.startDate, "ui.startDate")
    },
    textEndDate() {
      return this.getTextDateFormat(this.endDate, "ui.finishDate")
    },
    textPickStartDate() {
      return this.getTextDateFormat(this.pickStartDate, "ui.startDate")
    },
    textPickEndDate() {
      return this.getTextDateFormat(this.pickEndDate, "ui.endDate")
    },
    getTextCalendarColor() {
      return '#BFBFBF'
    },
    isSelectDisabled() {
      return this.pickStartDate === null || this.pickEndDate === null
    },
    isSaveTimeDisabled() {
      return this.pickStartTime === null || this.pickEndTime === null
    },
    isSelectedDate() {
      return this.startDate !== null && this.endDate !== null
    },
    // Updated validation - requires employee and at least one of: time, date, or repeat
    enableOnSave() {
      const hasEmployee = this.selectedEmployee;
      const hasTime = this.startTime && this.endTime;
      const hasDate = this.startDate || this.endDate;  
      const hasRepeat = this.selectRepeat.length > 0;
      const hasGroup = !this.isGroup || this.selectedGroup;
      
      return hasEmployee && (hasTime || hasDate || hasRepeat) && hasGroup;
    },
    select() {
      return this.$t('base.selectOption')
    }
  },
  methods: {
    onGoBack() {
      this.openTab(0)
    },
    onTab(item) {
      this.getListGroup();
      this.getListEmployee();
      this.getData(item)
    },
    async getData(item) {
      if (item) {
        // Use the new schedule validation API to check if the specific schedule exists
        let res = await this.get(API2.SCHEDULE, { path: item.scheduleId }, null, false)
        
        if (res && res.data && res.data.status === 200 && res.data.data) {
          // Schedule exists, use the passed item data
          this.schedule = item
          this.getInitialState(this.schedule)
        } else {
          // Schedule doesn't exist anymore, show toast and go back
          this.notifDialog({
            title: `${i18n.t("warning.warning")}!`,
            content: i18n.t("base.noData"),
            textConfirm: i18n.t('ui.confirm'),
          });
          this.onGoBack();
        }
      } else {
        this.schedule = null
        this.getInitialState(null)
      }
    },
    getInitialSelectRepeat(schedule) {
      let dayOfWeek = {
        everyMonday: DAY_OF_WEEK.MONDAY,
        everyTuesday: DAY_OF_WEEK.TUESDAY,
        everyWednesday: DAY_OF_WEEK.WEDNESDAY,
        everyThursday: DAY_OF_WEEK.THURSDAY,
        everyFriday: DAY_OF_WEEK.FRIDAY,
        everySaturday: DAY_OF_WEEK.SATURDAY,
        everySunday: DAY_OF_WEEK.SUNDAY,
      }
      return Object.keys(dayOfWeek)
          .filter(day => schedule[day].toString() === "1")
          .map(d => dayOfWeek[d]);
    },
    getInitialState(schedule) {
      this.getListGroup();
      this.getListEmployee();
      if (schedule) {
        this.mainOnDuty = schedule.mainOnDuty === 1;
        this.isGetNotifications = schedule.isGetNotifications === 1;
        this.selectRepeat = this.getInitialSelectRepeat(schedule);

        //date
        this.startDate = schedule.startDate ? moment(schedule.startDate, TYPE_FORMAT_TIME.YYYY_MM_DD) : null
        this.endDate = schedule.endDate ? moment(schedule.endDate, TYPE_FORMAT_TIME.YYYY_MM_DD) : null
        this.pickStartDate = null
        this.pickEndDate = null
        //time
        this.startTime = schedule.startTime ? schedule.startTime.substring(0, 5) : null
        this.endTime = schedule.endTime ? schedule.endTime.substring(0, 5) : null
        this.pickStartTime = null
        this.pickEndTime = null
        this.isGroup = schedule.scheduleType
      } else {
        this.mainOnDuty = true;
        this.isGetNotifications = true;
        this.selectRepeat = [];
        this.startDate = null
        this.endDate = null
        this.pickStartDate = null
        this.pickEndDate = null
        this.startTime = null
        this.endTime = null
        this.pickStartTime = null
        this.pickEndTime = null
        this.isGroup = false;
      }
    },
    async getListGroup() {
      this.listGroup = null
      this.selectedGroup = null
      let res = await this.get(API2.GROUP)
      if (res) {
        this.listGroup = res.data;
        if (this.schedule) {
          const filterGroup = res.data.filter(group => group.groupId === this.schedule.groupId)[0];
          if (filterGroup) {
            this.selectedGroup = filterGroup
          } else {
            this.selectedGroup = res.data[0]
          }
        } else {
          this.selectedGroup = res.data[0];
        }
      }
    },
    async getListEmployee() {
      this.selectedEmployee = null
      let res = await this.get(API2.EMPLOYEE)

      let accountInfo = this.accountInfo;
      if (accountInfo.roleId === 3 || accountInfo.webAccess) {
        // case nhân viên có quyền webAccess đăng nhập
        this.listEmployee = res.data?.map(i => ({... i, name: this.shortenText(i.name, 40) + ` (${i.email})`}));
      } else {
        // case nhân viên đăng nhập bị giới hạn quyền
        const departmentId = accountInfo.departmentInfo.departmentId;
        this.listEmployee = res.data
        ?.map(i => ({... i, name: this.shortenText(i.name, 40) + ` (${i.email})`}))
        ?.filter(value => value.departmentId === departmentId)
      }

      this.selectedEmployee = this.schedule ? this.listEmployee.find(item => item.employeeId === this.schedule.employeeId) : null
    },
    getValueDayOfWeek(value) {
      return this.selectRepeat.find(element => element === value) ? "1" : "0";
    },
    async onSave() {
      let type = this.schedule ? SCHEDULE_ACTION_TYPE.UPDATE : SCHEDULE_ACTION_TYPE.CREATE

      let data = {
        employeeId: this.selectedEmployee.employeeId,
        type: type,
        mainOnDuty: 1,
        isGetNotifications: 1,
        startTime: this.startTime,
        endTime: this.endTime,
        startDate: this.startDate ? moment(this.startDate).format(TYPE_FORMAT_TIME.YYYY_MM_DD) : null,
        endDate: this.endDate ? moment(this.endDate).format(TYPE_FORMAT_TIME.YYYY_MM_DD) : null,
        everyMonday: this.getValueDayOfWeek(DAY_OF_WEEK.MONDAY),
        everyTuesday: this.getValueDayOfWeek(DAY_OF_WEEK.TUESDAY),
        everyWednesday: this.getValueDayOfWeek(DAY_OF_WEEK.WEDNESDAY),
        everyThursday: this.getValueDayOfWeek(DAY_OF_WEEK.THURSDAY),
        everyFriday: this.getValueDayOfWeek(DAY_OF_WEEK.FRIDAY),
        everySaturday: this.getValueDayOfWeek(DAY_OF_WEEK.SATURDAY),
        everySunday: this.getValueDayOfWeek(DAY_OF_WEEK.SUNDAY),
        scheduleType: this.isGroup ? "1" : "0",
        groupId: this.isGroup ? this.selectedGroup.groupId : null,
      };

      if (type === SCHEDULE_ACTION_TYPE.UPDATE) {
        data.path = this.schedule.scheduleId
      }
      let res = this.item ? await this.put(API2.SCHEDULE, data) : await this.post(API2.SCHEDULE, data)

      if (!res) return
      this.showToast("success", i18n.t("base.notification"),
          type === SCHEDULE_ACTION_TYPE.UPDATE ? i18n.t("base.updateSuccessful") : i18n.t("base.createSuccessful"),
      )
      this.openTab(0)
    },
    getTextDateFormat(date, key) {
      if (date) return this.formatDate(date, TYPE_FORMAT_TIME.DD_MM_YYYY)
      else return i18n.t(key)
    },
    circleDateClass(date) {
      return date ? 'circle-border-selected' : ''
    },
    // Cancel chỉ đóng dialog, không thay đổi data  
    cancelSelectDate() {
      this.dialog = false
      // Reset picker về values hiện tại
      this.pickStartDate = this.startDate ? moment(this.startDate).format(TYPE_FORMAT_TIME.YYYY_MM_DD) : null
      this.pickEndDate = this.endDate ? moment(this.endDate).format(TYPE_FORMAT_TIME.YYYY_MM_DD) : null
    },
    // Confirm áp dụng picker values vào actual data
    confirmSelectDate() {
      this.dialog = false
      this.startDate = this.pickStartDate
      this.endDate = this.pickEndDate
    },
    // Clear data - đặt ở ngoài dialog
    onClearDate() {
      this.startDate = null
      this.endDate = null
      this.pickStartDate = null
      this.pickEndDate = null
    },
    clearTime() {
      this.startTime = null
      this.endTime = null
      this.pickStartTime = null
      this.pickEndTime = null
    },
    clearRepeat() {
      this.selectRepeat = []
    },
    isOpenDate() {
      if (this.item) {
        this.pickStartDate = this.startDate ? moment(this.startDate).format(TYPE_FORMAT_TIME.YYYY_MM_DD) : null
        this.pickEndDate = this.endDate ? moment(this.endDate).format(TYPE_FORMAT_TIME.YYYY_MM_DD) : null
      }
    },
    isOpenTime() {
      if (this.item) {
        this.pickStartTime = this.startTime ? this.startTime : null
        this.pickEndTime = this.endTime ? this.endTime : null
      }
    },
    confirmSelectTime() {
      this.timePicker = false
      this.startTime = this.pickStartTime
      this.endTime = this.pickEndTime
    },
    cancelSelectTime() {
      this.timePicker = false
      this.pickStartTime = this.startTime ? this.startTime : null
      this.pickEndTime = this.endTime ? this.endTime : null
    },
    onSwitchChange(newValue) {
      this.isGroup = newValue ? 1 : 0;
    },
    setDefaultData() {
      // Chỉ apply khi isGroup được bật
      if (!this.isGroup) return

      // ko lap lai, co time, co day
      if (this.selectRepeat.length === 0
          && this.startTime && this.endTime
          && this.startDate && this.endDate) {
        this.selectRepeat = [DAY_OF_WEEK.MONDAY, DAY_OF_WEEK.TUESDAY, DAY_OF_WEEK.WEDNESDAY, DAY_OF_WEEK.THURSDAY, DAY_OF_WEEK.FRIDAY, DAY_OF_WEEK.SATURDAY, DAY_OF_WEEK.SUNDAY,]
      }
      // ko time, co lap lai, co day
      if ((!this.startTime && !this.endTime) &&
          this.selectRepeat.length > 0
          && this.startDate && this.endDate) {
        this.pickStartTime = this.startTime = "00:00";
        this.pickEndTime = this.endTime = "23:59";
      }
      // ko day, co lap lai, co time
      if ((!this.startDate && !this.endDate) &&
          this.selectRepeat.length > 0
          && this.startTime && this.endTime) {
        this.pickStartDate = this.startDate = this.formatDate(new Date(), TYPE_FORMAT_TIME.YYYY_MM_DD)
      }
    },
    shortenText(text, maxLength) {
      return text.length > maxLength ? text.substring(0, maxLength) + "…" : text;
    },
    filterEmployee(item, queryText) {
      const search = queryText ? queryText.toLowerCase().trim() : '';
      if (!search) return true;
      const name = item.name ? item.name.toLowerCase() : '';
      const email = item.email ? item.email.toLowerCase() : '';
      return name.includes(search) || email.includes(search);
    },
  },
  watch: {
    isSelectedDate(newValue) {
      this.setDefaultData()
    },
    selectedTime(newValue) {
      this.setDefaultData()
    },
    selectRepeat(newValue) {
      this.setDefaultData()
    },
    isGroup(newValue) {
      this.setDefaultData()
    },
  }
}
</script>

<style scoped>
.v-input {
  font-size: 22px;
}

.card-border-10 >>> .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
  color: rgba(217, 217, 217, 1);
}

.circle-border {
  width: 40px;
  height: 40px;
  text-align: center;
  border-radius: 26px;
  border: 1px solid #BFBFBF;
  color: #BFBFBF;
}

.circle-border-selected {
  background: #1890FF;
  border: 1px solid #1890FF;
  color: #ffffff;
}
</style>